export default "__VITE_ASSET__yogq1WXY__"